<template>
  <div class="InformationalSlide">
    <SlideHeading v-bind="{ content }" />
    <SlideBodyText v-if="content.body" :blocks="content.body" class="bodyText"/>
    <SlideButton v-if="content.buttonText"
      :text="content.buttonText"
      :disabled="!isCurrentSlide"
      class="continueButton"
      @click="$emit('next')"
    />
  </div>
</template>

<script>
import SlideBodyText from './elems/SlideBodyText.vue'
import SlideButton from '../elems/SlideButton.vue'
import SlideHeading from './elems/SlideHeading.vue'

export default {
  components: {
    SlideBodyText,
    SlideButton,
    SlideHeading,
  },
  props: {
    content: Object,
    isCurrentSlide: Boolean,
    selectedOptions: Object,
    fieldConfig: Object,
    fieldValues: Object,
    fieldErrors: Object,
  },
}
</script>

<style scoped>
.bodyText {
  margin-top: var(--spacing-1);
}
</style>
